import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider.js";
import { TabBar } from "./TabBar.js";
import { MainRegion } from "./MainRegion.js";

/**
 * Public routes (welcome/login/register/forgot). If already authenticated,
 * bounce to /home — a logged-in customer shouldn't see the login screen.
 */
export function PublicLayout() {
  const { isAuthenticated } = useAuth();
  if (isAuthenticated) return <Navigate to="/home" replace />;
  return (
    <div className="app">
      <div className="phone-scroll">
        <MainRegion>
          <Outlet />
        </MainRegion>
      </div>
    </div>
  );
}

/**
 * Protected routes. Unauthenticated → /welcome, preserving where they were
 * headed so a deep link survives the login round-trip.
 */
export function ProtectedLayout() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  if (!isAuthenticated) {
    return <Navigate to="/welcome" replace state={{ from: location }} />;
  }
  return (
    <div className="app">
      <div className="phone-scroll">
        <MainRegion>
          <Outlet />
        </MainRegion>
        <TabBar />
      </div>
    </div>
  );
}
